"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./map.point.generic"), exports);
//# sourceMappingURL=index.js.map